import React, { useState } from "react";
import { saveItemDetail } from "../../service/ItemDetailRequest";

import {TextField,
    Button, Box, Container, makeStyles,
} from '@material-ui/core';
import {
    ItemDetailFormBottonControl,
} from './style/ItemDetailStyle';



const itemdetailStyles = makeStyles({
    field: {
        marginTop: 20,
        marginBottom: 10,

    },
});
export default function ItemDetailForm({handleAddClose, handleSubmit}) {
    const classes = itemdetailStyles();

    const [itemType, setItemType] = useState('');
    const [itemCode, setItemCode] = useState('');
    const [itemQuantity, setItemQuantity] = useState('');


    const handleSubmitData=async (e) =>{
        e.preventDefault();
        console.log('ItemDetailForm====');
        console.log('itemType===', itemType);
        console.log('itemCode===', itemCode);
        console.log('itemQuantity===', itemQuantity);

        const saveItemDetailDto = {
            'itemType': itemType,
            'itemCode': itemCode,
            'itemQuantity': itemQuantity
        };
        await saveItemDetail(saveItemDetailDto);

        console.log('===save====');

        handleSubmit();
    };
    return (
        <div>


            <Container >


                <form noValidate autoComplete="off" onSubmit={handleSubmitData}>


                <Box>
                        <TextField
                            onChange={((e)=> setItemCode(e.target.value))}
                            className={classes.field}
                            id="standard-disabled"
                            label="Item Code"
                            variant="standard"

                        />

                        <TextField id="itemType" className={classes.field} label="Item Type" variant="standard" onChange={((e)=> setItemType(e.target.value))}/>
                        <TextField id="itemQuantity" className={classes.field} label="Item Quantity" onChange={((e)=> setItemQuantity(e.target.value))} variant="standard"/>
                    
                    </Box>


                    <ItemDetailFormBottonControl>
                        <Button type="submit" variant="outlined" className="btn right">Submit</Button>
                        <Button variant ="outlined" onClick={handleAddClose} className="btn right">close</Button>

                    </ItemDetailFormBottonControl>

                </form>
            </Container>
        </div>
    );
}

